/**
 * Subscription configurator: remove orphan machine/gift lines.
 *
 * Lines added by the configurator are recognised by their properties:
 *  - coffee:  `_rc_bundle_parent`
 *  - machine: `_subscription` = "true" (no `_gift`)
 *  - gift:    `_subscription` = "true" and `_gift` = "true"
 *
 * Rules (checked on every cart change):
 *  - no configurator coffee left  -> remove machine and gift
 *  - no configurator machine left -> remove gift (coffee stays)
 *
 * Coffee that does not come from the configurator (no `_rc_bundle_parent`) and
 * machines added elsewhere (no `_subscription`) are never considered.
 */
(function () {
  if (window.__jklSubscriptionOrphansInit) return;
  window.__jklSubscriptionOrphansInit = true;

  var root =
    (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ||
    "/";
  var busy = false;

  function getProperty(item, name) {
    return item && item.properties ? item.properties[name] : undefined;
  }

  function isCoffee(item) {
    return !!getProperty(item, "_rc_bundle_parent");
  }

  function isGift(item) {
    return (
      getProperty(item, "_subscription") === "true" &&
      getProperty(item, "_gift") === "true"
    );
  }

  function isMachine(item) {
    return (
      getProperty(item, "_subscription") === "true" &&
      getProperty(item, "_gift") !== "true"
    );
  }

  function findOrphanKeys(cart) {
    var items = (cart && cart.items) || [];

    var hasCoffee = items.some(isCoffee);
    var hasMachine = items.some(isMachine);

    return items
      .filter(function (item) {
        if (isMachine(item)) return !hasCoffee;
        if (isGift(item)) return !hasCoffee || !hasMachine;
        return false;
      })
      .map(function (item) {
        return item.key;
      });
  }

  function removeOrphans(cart) {
    if (busy) return;

    var keys = findOrphanKeys(cart);
    if (!keys.length) return;

    var updates = {};
    keys.forEach(function (key) {
      updates[key] = 0;
    });

    busy = true;

    fetch(root + "cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ updates: updates }),
    })
      .then(function (response) {
        if (!response.ok) throw new Error("HTTP " + response.status);
        return response.json();
      })
      .then(function () {
        document.dispatchEvent(
          new CustomEvent("cart:refresh", { bubbles: true }),
        );
      })
      .catch(function (error) {
        console.error("Error removing orphan subscription lines:", error);
      })
      .then(function () {
        busy = false;
      });
  }

  document.documentElement.addEventListener("cart:change", function (event) {
    removeOrphans(event.detail && event.detail.cart);
  });

  // Carts left over from previous sessions: check when the cart page is opened
  var path = window.location.pathname.replace(/\/$/, "");
  if (/\/cart$/.test(path)) {
    fetch(root + "cart.js")
      .then(function (response) {
        return response.json();
      })
      .then(removeOrphans)
      .catch(function () {});
  }
})();
